import { Show } from '@elfsight/lib-utils';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { Portal, PortalNestProvider } from '@elfsight/widget-modal';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot,
  ShadowEmbedRoot,
  useFontsLoader
} from '@elfsight/widget-ui';
import { StorageProvider } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { camelCase } from 'es-toolkit';
import { meta } from '../constants';
import { ChannelsProvider } from './channels';
import { ChatProvider } from './chat';
import { Filters } from './filters';
import { Main } from './main';

interface FloatingWindowProps {
  customCSSPrefixClassName: string;
}

const FloatingWindow = ({ customCSSPrefixClassName }: FloatingWindowProps) => (
  <PortalNestProvider customCSSClassName={customCSSPrefixClassName}>
    <Portal>
      <Main />
    </Portal>
  </PortalNestProvider>
);

export const Chats = () => {
  const {
    widgetId,
    position,
    font,
    customCSS,
    customJS,
    editMode,
    renderThumbnailMode,
    _shadowDOMDisabled
  } = useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );

  useDefineAPISchema();
  useFontsLoader([font]);
  useCustomJS(customJS, editMode || renderThumbnailMode);

  const isFloating = position === 'floating';

  return (
    <StorageProvider
      widgetId={widgetId || 'mockId'}
      name={camelCase(meta.alias)}
    >
      <Filters>
        <ChatProvider>
          <ChannelsProvider>
            <Show when={!_shadowDOMDisabled}>
              <ShadowEmbedRoot
                fullWidth={false}
                font={font}
                customCSS={customCSS}
                customCSSClassName={customCSSPrefixClassName}
              >
                <PortalNestProvider>
                  <Show when={isFloating} fallback={<Main />}>
                    <Portal>
                      <Main />
                    </Portal>
                  </Show>
                </PortalNestProvider>
              </ShadowEmbedRoot>
            </Show>
            <Show when={_shadowDOMDisabled === true}>
              <CustomCSS
                customCSS={customCSS}
                prefixClassName={customCSSPrefixClassName}
              />
              <Show
                when={isFloating}
                fallback={
                  <EmbedRoot
                    fullWidth={false}
                    customCSSClassName={customCSSPrefixClassName}
                  >
                    <Main />
                  </EmbedRoot>
                }
              >
                <FloatingWindow
                  customCSSPrefixClassName={customCSSPrefixClassName}
                />
              </Show>
            </Show>
          </ChannelsProvider>
        </ChatProvider>
      </Filters>
    </StorageProvider>
  );
};
